import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="service-gallery"
export default class extends Controller {
  static targets = ["card"]

  toggle(event) {
    const serviceId = this.element.dataset.serviceId;
    const frame = document.getElementById(`service_gallery_${serviceId}`);
    if (!frame) return;

    // If already loaded, just toggle visibility
    if (frame.innerHTML.trim() !== "") {
      if (frame.style.display === "none") {
        frame.style.display = "";
      } else {
        frame.style.display = "none";
      }
      return;
    }

    // Otherwise, fetch and show
    this.cardTarget.classList.add('loading');
    frame.src = `/service_gallery?service_id=${serviceId}`;
    frame.onload = () => {
      this.cardTarget.classList.remove('loading');
    };
  }
}
